const sideBarConstantsAR = {
  dashboard: 'لوحة التحكم',
  reports: 'التقارير',
  userManagement: 'إدارة المستخدم',
  pages: 'الصفحات',
  approvedDomain: 'النطاقات المعتمدة',
  usersApproval: 'طلبات تسجيل المستخدمين',
  proposalRequests: 'طلبات عروض الأسعار',
  purchaseRequests: 'موافقات المستخدمين',
  reviews: 'المراجعات',
  videosManagement: 'إدارة مقاطع الفيديو',
  logOut: 'تسجيل خروج',
  blogs: 'المدونات',
  successStories: 'قصص النجاح',
  news: 'الأخبار',
  messageCenter: 'المراسلات',
  manageProfile: 'إدارة الملف الشخصي',
  settings: 'الإعدادات',
  ordersManagement: 'إدارة الطلبات',
  deletedMedia: 'الوسائط المحذوفة'
};

export default sideBarConstantsAR;
